// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__box--wRBUV {
  padding: 16px 24px;
  border-top: 1px solid #0000000f;
  height: 100%;
  overflow: hidden;
}
.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__content--fAlf0 {
  height: 100%;
  overflow: hidden;
}
.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__title--Wrmr3 {
  padding: 16px 24px 20px 24px;
  background: #fff;
  font-size: 20px;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedulingControl/SchedulingControl.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;AACF;AAEA;EACE,YAAA;EACA,gBAAA;AAAF;AAGA;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AADF","sourcesContent":[".box {\n  padding: 16px 24px;\n  border-top: 1px solid #0000000f;\n  height: 100%;\n  overflow: hidden;\n}\n\n.content {\n  height: 100%;\n  overflow: hidden;\n}\n\n.title {\n  padding: 16px 24px 20px 24px;\n  background: #fff;\n  font-size: 20px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__box--wRBUV`,
	"content": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__content--fAlf0`,
	"title": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingControl-module__title--Wrmr3`
};
export default ___CSS_LOADER_EXPORT___;
